import colors from "tailwindcss/colors";

// Color values using Tailwind's color palette
export const CHART_COLORS = {
  PURPLE: colors.purple[400],
  VIOLET: colors.violet[400],
  INDIGO: colors.indigo[400],
  BLUE: colors.blue[400],
  SKY: colors.sky[400],
  CYAN: colors.cyan[400],
  TEA: colors.teal[400],
  EMERALD: colors.emerald[400],
  GREEN: colors.green[400],
  LIME: colors.lime[400],
  YELLOW: colors.yellow[400],
  AMBER: colors.amber[400],
  ORANGE: colors.orange[400],
  RED: colors.red[400],
  ROSE: colors.rose[400],
  PINK: colors.pink[400],
  FUSIA: colors.fuchsia[400],
  GRAY: colors.gray[300],
};

// https://www.figma.com/design/wapSdbtuQMFzXXwpqeM7C8/Reports?node-id=4100-123997&t=bS3nlwMaZBm006AZ-11

// See the FIGMA link above for the logic around matching colors to a chart index and series size.
// Because as options increase we're adding new color options to various points in the options — not
// just the end, but to the middle and beginning — we're defining all the color choices available
// depending on how many total colors will display. Once we hit 11 total colors, new colors only get
// added to the end and we can just use the complete list of 17 color options.

// Define the color arrays for different counts
export const colorArrays = {
  4: [
    CHART_COLORS.INDIGO,
    CHART_COLORS.SKY,
    CHART_COLORS.TEA,
    CHART_COLORS.GREEN,
  ],
  5: [
    CHART_COLORS.PURPLE,
    CHART_COLORS.INDIGO,
    CHART_COLORS.SKY,
    CHART_COLORS.TEA,
    CHART_COLORS.GREEN,
  ],
  6: [
    CHART_COLORS.PURPLE,
    CHART_COLORS.INDIGO,
    CHART_COLORS.BLUE,
    CHART_COLORS.TEA,
    CHART_COLORS.GREEN,
    CHART_COLORS.LIME,
  ],
  7: [
    CHART_COLORS.PURPLE,
    CHART_COLORS.INDIGO,
    CHART_COLORS.BLUE,
    CHART_COLORS.CYAN,
    CHART_COLORS.TEA,
    CHART_COLORS.GREEN,
    CHART_COLORS.LIME,
  ],
  8: [
    CHART_COLORS.PURPLE,
    CHART_COLORS.VIOLET,
    CHART_COLORS.INDIGO,
    CHART_COLORS.BLUE,
    CHART_COLORS.CYAN,
    CHART_COLORS.TEA,
    CHART_COLORS.GREEN,
    CHART_COLORS.LIME,
  ],
  9: [
    CHART_COLORS.PURPLE,
    CHART_COLORS.VIOLET,
    CHART_COLORS.INDIGO,
    CHART_COLORS.BLUE,
    CHART_COLORS.CYAN,
    CHART_COLORS.TEA,
    CHART_COLORS.EMERALD,
    CHART_COLORS.LIME,
    CHART_COLORS.YELLOW,
  ],
  10: [
    CHART_COLORS.PURPLE,
    CHART_COLORS.VIOLET,
    CHART_COLORS.INDIGO,
    CHART_COLORS.BLUE,
    CHART_COLORS.SKY,
    CHART_COLORS.CYAN,
    CHART_COLORS.TEA,
    CHART_COLORS.EMERALD,
    CHART_COLORS.LIME,
    CHART_COLORS.YELLOW,
  ],
  17: [
    CHART_COLORS.PURPLE,
    CHART_COLORS.VIOLET,
    CHART_COLORS.INDIGO,
    CHART_COLORS.BLUE,
    CHART_COLORS.SKY,
    CHART_COLORS.CYAN,
    CHART_COLORS.TEA,
    CHART_COLORS.EMERALD,
    CHART_COLORS.GREEN,
    CHART_COLORS.LIME,
    CHART_COLORS.YELLOW,
    CHART_COLORS.AMBER,
    CHART_COLORS.ORANGE,
    CHART_COLORS.RED,
    CHART_COLORS.ROSE,
    CHART_COLORS.PINK,
    CHART_COLORS.FUSIA,
  ],
};

const getColorArrayKey = (count) => {
  if (count <= 4) return 4;
  if (count <= 5) return 5;
  if (count <= 6) return 6;
  if (count <= 7) return 7;
  if (count <= 8) return 8;
  if (count <= 9) return 9;
  if (count <= 10) return 10;
  return 17;
};

export const getChartColor = (index, count) => {
  const selectedCount = getColorArrayKey(count);

  if (index >= colorArrays[selectedCount].length) {
    return colorArrays[selectedCount][
      index % colorArrays[selectedCount].length
    ];
  }

  return colorArrays[selectedCount][index];
};
